import { render } from "./CatalogBody.vue?vue&type=template&id=3b6bec55&scoped=true"
import script from "./CatalogBody.vue?vue&type=script&lang=js"
export * from "./CatalogBody.vue?vue&type=script&lang=js"

import "./CatalogBody.vue?vue&type=style&index=0&id=3b6bec55&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6bec55"]])

export default __exports__